<template>
  <div class="stategyNew">
    <div
      style="display: flex;flex-direction: column;flex: 1;overflow: auto;"
      v-if="strategynewValue==1"
    >
      <div class="stategyIntro">
        <div class="stategyIntroTitle">
          <p style="font-size: 20px;line-height: 26px;">{{$t('strategy.strategyIntro')}}</p>
          <div class="stategyIntroDisc">
            <span class="strategyIntro"></span>
            <span>{{$t('strategy.strategyIntro1') }}</span>
          </div>
        </div>
        <div class="stategyStep">
          <div class="stategyStepDiv">
            <div class="stategyStepOne">
              <p>01</p>
              <p>{{$t('strategy.stategyStep2') }}</p>
              <p>{{$t('strategy.stategyStep3') }}</p>
            </div>
            <div class="stategyTriangle"></div>
          </div>
          <div class="stategyStepDiv">
            <div class="stategyStepOne">
              <p>02</p>
              <p>{{$t('strategy.stategyStep6') }}</p>
              <p>{{$t('strategy.stategyStep7') }}</p>
            </div>
            <div class="stategyTriangle"></div>
          </div>
          <!-- <div class="stategyStepDiv">
            <div class="stategyStepOne">
              <p>03</p>
              <p>{{$t('strategy.stategyStep4') }}</p>
              <p>{{$t('strategy.stategyStep5') }}</p>
            </div>
            <div class="stategyTriangle"></div>
          </div> -->
          <div class="stategyStepDiv">
            <div class="stategyStepOne">
              <p>03</p>
              <p>{{$t('strategy.stategyStep8') }}</p>
              <p>{{$t('strategy.stategyStep9') }}</p>
            </div>
            <div class="stategyTriangle"></div>
          </div>
        </div>
      </div>
      <div class="section">
        <div class="search">
          <div class="searchLeft">
            <span class="search-label">{{ $t('strategy.strategy_status') }}</span>
            <el-select
              v-model="search.status"
              clearable
              @change="queryGetStrategyList(true)"
              :placeholder="$t('header.pleaseSelect')"
              popper-class="select-search-recharge"
              class="selectClearNew"
            >
              <el-option
                v-for="(value, key) in strategyStatus"
                :key="key"
                :value="value.value"
                :label="value.label"
                style="display:flex;align-items:center;"
              >
                <span class="select-label">{{ value.label }}</span>
              </el-option>
            </el-select>
            <!-- <span class="search-label">{{ $t('strategy.uprade_type') }}</span> -->
            <!-- <el-select
              v-model="search.type"
              clearable
              @change="queryGetStrategyList(true)"
              :placeholder="$t('header.pleaseSelect')"
              popper-class="select-search-recharge"
              class="selectClearNew"
            >
              <el-option
                v-for="(value, key) in upgradeType"
                :key="key"
                :value="key"
                :label="value.label"
                style="display:flex;align-items:center;"
              >
                <span class="select-label">{{ value.label }}</span>
              </el-option>
            </el-select> -->
            <!-- <el-date-picker :editable='false' v-model="search.time" @change="queryGetStrategyList()"
              type="daterange" align="left" :default-value="new Date().setMonth(new Date().getMonth() - 1)" unlink-panels ref="strategyNewRangeData"
              :start-placeholder="$t('strategy.start_date')" :end-placeholder="$t('strategy.End_date')"
              style="width:350px;positon:relative;" popper-class="select-date1">
            </el-date-picker>-->
          </div>
          <div class="searchRight">
            <!-- 搜索 -->
            <div class="search-alert" v-if="this.$store.state.user.role == 1 && showSearch">
              <!-- :placeholder="$t('recharge.pn')" -->
              <!-- v-model="inputText" -->
              <!-- @input实时查询 -->
              <!-- @keyup.enter.native -->
              <div class="searchDiv">
                <el-input
                  class="searchAll"
                  ref="iptFocus"
                  v-model.trim="search.search"
                  @keyup.enter.native="queryGetStrategyList(true)"
                  :placeholder="this.$t('strategy.stategyDetail')"
                  clearable
                >
                  <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-input>
                <!-- 搜索 -->
                <span
                  class="search-device"
                  @click="queryGetStrategyList(true)"
                >{{ $t('recharge.Search') }}</span>
                <!-- 取消 -->
                <span class="search-hide" @click="closeSearch">{{ $t('rate.cancel') }}</span>
              </div>
            </div>
            <el-button class="button button-solid" @click.stop="showSearchBtn">
              <i class="el-icon-search"></i>
            </el-button>
            <!-- 添加策略 -->
            <button
              type="button"
              class="button-upload"
              @click="addstrategy()"
            >{{ $t('strategy.stategyStep6') }}</button>
          </div>
        </div>
        <el-table
          class="tablemain tableloding"
          v-loading="isLoading"
          element-loading-spinner="el-icon-loading"
          height="100%"
          stripe
          border
          :data="strategyDataList"
          :header-cell-style="{ background: 'rgb(65, 80, 90)', color: '#ffffff' }"
          :empty-text="$t('account.nodata')"
        >
          <!-- <el-table-column
            prop="id"
            width="80px;"
            :show-overflow-tooltip="true"
            :label="$t('strategy.strategy_code')"
          ></el-table-column> -->
          <el-table-column
            prop="strategyName"
            min-width="90px;"
            :show-overflow-tooltip="true"
            :label="$t('strategy.strategy_name')"
          ></el-table-column>
          <el-table-column
            prop="strategyDesc"
            min-width="90px;"
            :show-overflow-tooltip="true"
            :label="$t('strategy.strategy_desc')"
          ></el-table-column>
          <el-table-column
            prop="firmwareName"
            min-width="90px;"
            :show-overflow-tooltip="true"
            :label="$t('strategy.strategy_firmware')"
          >
          </el-table-column>
          <el-table-column
            prop="firmwareType"
            min-width="90px;"
            :show-overflow-tooltip="true"
            :label="$t('strategy.strategy_type')"
          >
          <template slot-scope="scope">
            <span v-if="firmwaretypelist.length">{{firmwaretypelist.filter(i => i.id ==  scope.row.firmwareTypeId)[0].typeName }}</span>
          </template>
          </el-table-column>
          <el-table-column
            prop="baudrate"
            min-width="100px;"
            :show-overflow-tooltip="true"
            :label="$t('strategy.stategyDetail4')"
          >
          </el-table-column>
          <el-table-column
            prop="upgradeDeviceCount"
            width="120px;"
            :show-overflow-tooltip="true"
            :label="$t('strategy.upNum')"
          ></el-table-column>
          <el-table-column
            prop="strategyStatus"
            min-width="100px;"
            :show-overflow-tooltip="true"
            :label="$t('strategy.strategy_status')"
          >
            <template slot-scope="scope">
              <div
                v-if="scope.row.strategyStatus==0"
                style="background-color: rgba(84,160,255,0.16);border-radius: 5px;"
              >
                <i
                  style="margin-right:5px;width:8px;height:8px;background-color: #54A0FF;border-radius: 5px;display: inline-block;"
                ></i>
                <span style="color:#54A0FF;">{{$t('strategy.Not_started')}}</span>
              </div>
              <div
                v-if="scope.row.strategyStatus==2"
                style="background-color: rgba(183,183,183,0.16);border-radius: 5px;"
              >
                <i
                  style="margin-right:5px;width:8px;height:8px;background-color: #B7B7B7;border-radius: 5px;display: inline-block;"
                ></i>
                <span style="color:#B7B7B7;">{{$t('strategy.expired')}}</span>
              </div>
              <div
                v-if="scope.row.strategyStatus==1"
                style="background-color: rgba(48,236,112,0.16);border-radius: 5px;"
              >
                <i
                  style="margin-right:5px;width:8px;height:8px;background-color: #30EC70;border-radius: 5px;display: inline-block;"
                ></i>
                <span style="color:#30EC70;">{{$t('strategy.In_effect')}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="effectTime"
            min-width="90px;"
            :show-overflow-tooltip="true"
            :label="$t('device.device_upgradeTime')"
          ></el-table-column>
          <el-table-column
            :label="this.$t('firmware.Operation')"
            fixed="right"
            width="150px"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                class="operation"
                :title="$t('strategy.view')"
                @click="viewStrategy(scope.row)"
              >
                <i class="iconfont icon-baobiao"></i>
              </el-button>

              <el-button
                :class="{ 'operation1': scope.row.strategyStatus!=0 ? true : false}"
                :disabled="scope.row.strategyStatus!=0 ? true : false"
                type="text"
                class="operation"
                :title="$t('strategy.cancel')"
                @click="delStrategy(scope.row)"
              >
                <i class="iconfont icon-a-mingchengcha2"></i>
              </el-button>

              <el-button
                :class="{ 'operation1': scope.row.strategyStatus!=2 ? true : false }"
                :disabled="scope.row.strategyStatus!=2? true : false"
                type="text"
                class="operation"
                :title="$t('account.Delete')"
                @click="DeleteStrategy(scope.row)"
              >
                <i class="iconfont icon-caozuo_shanchu"></i>
              </el-button>
            </template>
          </el-table-column>
          <!-- 无数据 -->
          <!-- <div v-show="emptyText" slot="empty"><img src="@/assets/img/empty_text.png"/>
          <div style="line-height: 32px">{{$t('account.nodata')}}</div></div>-->
        </el-table>
        <div class="tablebottom">
          <!-- 批量占位 -->
          <span class style="margin-left:16px;"></span>
          <!-- v-show="paginationControl" -->
          <el-pagination
            class="pagination"
            background
            @size-change="queryGetStrategyList(true)"
            @current-change="() => queryGetStrategyList()"
            :current-page.sync="pagination.currentPage"
            :page-sizes="[10, 15, 20, 30, 50]"
            :page-size.sync="pagination.pagesize"
            layout="slot, sizes, total, pager, prev, next, jumper"
            :total="pagination.total"
            popper-class="select-page"
          >
            <span style="color:#ffffff;padding-left:15px;">{{ $t('device.pageSize') }} :</span>
          </el-pagination>
        </div>
      </div>
    </div>
    <addStrategyNew @noticeStrategyNewBox="showStrategyNewListBox" v-if="strategynewValue==2"></addStrategyNew>
    <viewStrategyNew
      @noticeStrategyNewBox="showStrategyNewListBox"
      :strategynewListParam="strategynewListParam"
      v-if="strategynewValue==3"
    ></viewStrategyNew>
    <!-- 编辑策略弹窗 -->
    <strategy-dialog
      :title="$t('strategy.edit_strategy')"
      :class="{ 'showDialog': editdialog, 'hideDialog': !editdialog }"
      :visible.sync="editdialog"
      width="40vw"
      noFooter
    >
      <el-form
        ref="editStrategyData"
        :model="editStrategyData"
        :rules="editStrategyDataRules"
        slot="content"
        class="bianji grid"
        element-loading-spinner="el-icon-loading"
      >
        <el-form-item :label="`${$t('strategy.strategy_name')}：`" prop="strategyName">
          <el-input :maxlength="32" clearable type="text" v-model="editStrategyData.strategyName"></el-input>
        </el-form-item>
        <el-form-item :label="`${$t('strategy.strategy_desc')}：`" prop="strategyDesc">
          <el-input :maxlength="100" clearable type="text" v-model="editStrategyData.strategyDesc"></el-input>
        </el-form-item>
        <!-- 升级固件 -->
        <el-form-item prop="strategyFirmware" :label="`${$t('strategy.strategy_firmware')}：`">
          <!-- :placeholder="$t('project.defaultProject')" -->
          <el-select
            v-model="editStrategyData.strategyFirmware"
            placeholder
            popper-class="select-search-recharge"
          >
            <el-option
              v-for="item in firmwaresData"
              :key="item.id"
              :value="item.firmwareName"
              :label="item.firmwareName"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 固件类型 -->
        <el-form-item prop="strategyType" :label="`${$t('strategy.strategy_type')}：`">
          <!-- :placeholder="$t('project.defaultProject')" -->
          <el-select
            v-model="editStrategyData.strategyType"
            placeholder
            popper-class="select-search-recharge"
          >
            <el-option
              v-for="item in firmwaretypelist"
              :key="item.id"
              :value="item.typeName"
              :label="item.typeName"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 波特率 -->
        <el-form-item prop="strategyBaudrate" :label="`${$t('strategy.strategy_baudrate')}：`">
          <!-- :placeholder="$t('project.defaultProject')" -->
          <el-select
            v-model="editStrategyData.strategyBaudrate"
            placeholder
            popper-class="select-search-recharge"
          >
            <el-option
              v-for="item in bratelist"
              :key="item.value"
              :value="item.value"
              :label="item.label"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 生效时间 -->
        <el-form-item
          class="edit_data"
          style
          prop="strategyTime"
          :label="`${$t('strategy.start_time')}：`"
        >
          <!-- <el-date-picker v-model="addStrategyData.strategyTime" type="date" :editable="false" :clearable="false"
          popper-class="select-date"></el-date-picker>-->
          <el-date-picker
            :editable="false"
            v-model="editStrategyData.strategyTime"
            type="daterange"
            align="left"
            unlink-panels
            ref="strategyNewRangeData"
            :picker-options="pickerrangeOptions"
            :start-placeholder="$t('strategy.start_date')"
            :end-placeholder="$t('strategy.End_date')"
            style="width:100%;positon:relative;"
            popper-class="select-date1"
          ></el-date-picker>
        </el-form-item>
        <el-form-item
          :label="`${$t('strategy.uprade_type')}：`"
          prop="upradeType"
          class="el-form-group-item"
        >
          <el-radio-group
            v-model="editStrategyData.upradeType"
            v-removeAriaHidden
            class="eb-radio-group"
          >
            <el-radio :label="0">{{$t('strategy.uprade_name')}}</el-radio>
            <el-radio :label="1">{{$t('strategy.uprade_name1')}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="`${$t('strategy.upgrade_remind')}：`" prop="note">
          <el-input
            type="textarea"
            :placeholder="$t('firmware.enter_content')"
            v-model="editStrategyData.note"
            :maxlength="100"
            show-word-limit
          ></el-input>
        </el-form-item>
        <!-- Grid占位 -->
        <div></div>
        <div style="text-align:right;">
          <button
            type="button"
            class="btn btn-dark"
            @click="configedit()"
            style="margin-right:10px;"
          >
            {{
            $t('firmware.confirm') }}
          </button>
          <button
            type="button"
            class="btn btn-light"
            @click="editdialog = false"
          >{{ $t('firmware.cancel') }}</button>
          <!-- <button class="button-hollow" @click="closeDialog">{{$t('account.cancel')}}</button> -->
        </div>
      </el-form>
    </strategy-dialog>
    <!-- 取消策略对话框 -->
    <!-- v-if="dialogVisible" -->
    <strategy-dialog
      :title="$t('strategy.cancel_strategy')"
      :visible.sync="cenceldialog"
      :class="{ 'showDialog': cenceldialog, 'hideDialog': !cenceldialog }"
      width="35vw"
      noFooter
    >
      <div class="content_tishi" slot="content">
        <div class="tital">
          <!-- <i class="iconfont icon-gantanhao"></i> -->
          <span
            class="contentdelete"
            style="width:100%;text-align:left;"
          >{{ $t('strategy.delete_firmware') }}</span>
        </div>
        <div class="disabledescr">
          <span style="width:100%;text-align:left;margin-top:28px;">{{ $t('strategy.delete_desc') }}</span>
        </div>
        <!-- <span class="contentdelete">{{$t('firmware.delete_firmware')}}</span> -->
        <div class="deletfotter" style="text-align:right;margin-top:28px;">
          <button
            type="button"
            class="btn btn-dark"
            @click="configdelete()"
            style="margin-right:10px;"
          >
            {{
            $t('firmware.confirm') }}
          </button>
          <button
            type="button"
            class="btn btn-light"
            @click="cenceldialog = false"
          >{{ $t('firmware.cancel') }}</button>
        </div>
      </div>
    </strategy-dialog>
    <strategy-dialog :title="$t('strategy.deletCL')" :visible.sync="deleteFirmwareVisible"
      :class="{ 'showDialog': deleteFirmwareVisible, 'hideDialog': !deleteFirmwareVisible }" width="35vw" noFooter>
      <div class="content_tishi" slot="content">
        <div class="tital">
          <!-- <i class="iconfont icon-gantanhao"></i> -->
          <span class="contentdelete" style="width:100%;text-align:left;">{{$t('strategy.deletCL_TEST')}}</span>
        </div>
        <div class="disabledescr">
          <!-- <span style="width:100%;text-align:left;margin-top:28px;">{{ $t('upgradeManagement.delete_desc') }}</span> -->
        </div>
        <!-- <span class="contentdelete">{{$t('firmware.delete_firmware')}}</span> -->
        <div class="deletfotter" style="text-align:right;margin-top:28px;">
          <button type="button" class="btn btn-dark" @click="deletetoCL()" style="margin-right:10px;">{{
            $t('firmware.confirm') }}</button>
          <button type="button" class="btn btn-light" @click="deleteFirmwareVisible = false">{{ $t('firmware.cancel') }}</button>
        </div>
      </div>
    </strategy-dialog>
  </div>
</template>
  <script>
import strategyDialog from "@/components/dialognew";
import addStrategyNew from "./energyAddstrategy";
import viewStrategyNew from "./energyviewstrategy";
export default {
  components: {
    strategyDialog,
    addStrategyNew,
    viewStrategyNew
  },
  data() {
    return {
      strategynewListParam: null,
      strategynewValue: 1,
      bratelist: [
        {
          //默认
          // label: i18n.t("device.default"),
          label: "0bps",
          value: 0
        },
        {
          label: "1200bps",
          value: 1200
        },
        {
          label: "2400bps",
          value: 2400
        },
        {
          label: "4800bps",
          value: 4800
        },
        {
          label: "9600bps",
          value: 9600
        },
        {
          label: "19200bps",
          value: 19200
        },
        {
          label: "38400bps",
          value: 38400
        },
        {
          label: "57600bps",
          value: 57600
        },
        {
          label: "115200bps",
          value: 115200
        }
      ],
      // 固件包数据
      firmwaresData: [],
      // 固件类型
      firmwaretypelist: [],
      // 策略列表数据
      strategyDataList: [],
      // 策略列表id
      strategyListId: "",
      //自定义日期选择限定31天
      startDate: "",
      pickerrangeOptions: {
        //时间范围选择控制
        onPick: ({ maxDate, minDate }) => {
          this.startDate = minDate && minDate.getTime();
          if (maxDate) {
            // 选中后一个时，要把第一个的赋值清空
            this.startDate = "";
          }
        },
        disabledDate: time => {
          // 选中第一个后，后一个前后31天可选，超出的不可选，超出当前天也不可选，这里的天数按需求设定
          const minTime = new Date(this.startDate)
            .setDate

            // new Date(this.startDate).getDate() - 30
            ();
          const maxTime = new Date(this.startDate)
            .setDate
            // new Date(this.startDate).getDate() + 30
            ();
          return (
            time.getTime() < Date.now() - 8.64e7 ||
            (this.startDate
              ? time.getTime() < minTime || time.getTime() < maxTime
              : false)
          );
        }
      },
      datevalue: new Date(),
      // 编辑策略开关
      editdialog: false,
      // 取消策略开关
      cenceldialog: false,
      // 删除开关
      deleteFirmwareVisible:false,
      StrategyID:null,
      // 编辑数据
      editStrategyData: {
        strategyName: "",
        strategyDesc: "",
        strategyFirmware: "",
        strategyType: "",
        strategyBaudrate: "",
        strategyTime: [],
        upradeType: "",
        note: ""
      },
      // 编辑表单校验
      editStrategyDataRules: {
        strategyName: [
          {
            required: true,
            message: this.$t("strategy.message_name"),
            trigger: ["blur", "change"]
          }
        ],
        strategyDesc: [
          {
            required: true,
            message: this.$t("strategy.message_desc"),
            trigger: ["blur", "change"]
          }
        ],
        strategyFirmware: [
          {
            required: true,
            message: this.$t("strategy.message_firmware"),
            trigger: ["blur", "change"]
          }
        ],
        strategyType: [
          {
            required: true,
            message: this.$t("strategy.message_type"),
            trigger: ["blur", "change"]
          }
        ],
        strategyBaudrate: [
          {
            required: true,
            message: this.$t("strategy.message_baudrate"),
            trigger: ["blur", "change"]
          }
        ],
        strategyTime: [
          {
            required: true,
            message: this.$t("strategy.message_time"),
            trigger: ["blur", "change"]
          }
        ],
        upradeType: [
          {
            required: true,
            message: this.$t("strategy.message_uprade_type"),
            trigger: ["blur", "change"]
          }
        ]
      },
      search: {
        status: "",
        type: "",
        time: "",
        pn: "",
        search: ""
      },
      upgradeType: [
        {
          label: this.$t("strategy.force_upgrade"),
          value: "0"
        },
        {
          label: this.$t("strategy.suggested_upgrade"),
          value: "1"
        }
      ],
      strategyStatus: [
        {
          label: this.$t("strategy.Not_started"),
          value: "0"
        },
        {
          label: this.$t("strategy.expired"),
          value: "2"
        },
        {
          label: this.$t("strategy.In_effect"),
          value: "1"
        }
      ],
      isLoading: false,
      pagination: {
        currentPage: 1,
        pagesize: 15,
        // 默认 0
        total: 0
      },
      // 搜索开关
      showSearch: false
    };
  },
  watch: {
    editdialog(val) {
      if (!val) {
        if (this.$refs.strategyNewRangeData)
          this.$refs.strategyNewRangeData.handleClose();
        document.removeEventListener("click", this.handleDocumentClick, true);
      } else {
        document.addEventListener("click", this.handleDocumentClick, true);
      }
    }
  },
  created() {
    this.queryGetStrategyList();
    // this.getFirmwares();
    this.getFirmwaresType();
  },
  methods: {
    handleDocumentClick(event) {
      if (
        this.$refs.strategyNewRangeData &&
        !this.$refs.strategyNewRangeData.$el.contains(event.target) &&
        event.target.closest(".select-date1") == null
      ) {
        this.$refs.strategyNewRangeData.handleClose();
      }
    },
    // 查询固件类型
    getFirmwaresType() {
      this.$request
        .getUPG("/upg/api/auth/web/device/upgradeType/getTypeByUid")
        .then(res => {
          if (res.code == 0) {
            this.firmwaretypelist = res.data.items;
          }
        });
    },
    // 查询固件包
    getFirmwares() {
      let parmas = {
        deleteFlag: 0,
        pageSize: 100,
        page: 1,
        i18n: this.$lang.currentLang
      };
      this.$request
        .getUPG("/upg/api/auth/web/device/firmwares", parmas)
        .then(res => {
          if (res.code == 0) {
            this.firmwaresData = res.data.items;
          } else {
            this.firmwaresData = [];
          }
        });
    },
    // 策略列表数据
    queryGetStrategyList(reset) {
      if (reset) this.pagination.currentPage = 1;
      let param = {
        strategyName: this.search.search,
        strategyStatus: this.search.status,
        strategyType: this.search.type,
        startTime: this.search.time
          ? this.$filter.formatDate(this.search.time[0])
          : "",
        endTime: this.search.time
          ? this.$filter.formatDate(this.search.time[1])
          : "",
        page: this.pagination.currentPage,
        pageSize: this.pagination.pagesize,
        operate:'page',
        i18n: this.$lang.currentLang
      };
      this.$request
        .get("deviceFirmwareUpgradeStrategy", param)
        .then(res => {
          if (res.err == 0) {
            this.strategyDataList = res.dat.data;
            this.pagination.total = Number(res.dat.total);
          } else {
            this.strategyDataList = [];
            this.pagination.total = 0;
          }
        });
    },
    // 编辑策略
    editStrategy(info) {
      this.editdialog = true;
      let strategyTime = [];
      strategyTime.push(info.startTime, info.endTime);
      this.editStrategyData.strategyName = info.strategyName;
      this.editStrategyData.strategyDesc = info.description;
      this.editStrategyData.strategyFirmware = info.firmwareName;
      this.editStrategyData.strategyType = info.firmwareType;
      this.editStrategyData.strategyBaudrate = info.baudrate;
      this.editStrategyData.upradeType = info.strategyType;
      this.editStrategyData.note = info.note;
      this.editStrategyData.strategyTime = strategyTime;
      this.strategyListId = info.id;
    },
    // 编辑策略提交
    configedit() {
      this.$refs.editStrategyData.validate(valid => {
        if (!valid) return false;
        let strategyType;
        let strategyFirmware;
        this.firmwaretypelist.forEach(item => {
          if (item.typeName == this.editStrategyData.strategyType) {
            strategyType = item.id;
          }
        });
        this.firmwaresData.forEach(item => {
          if (item.firmwareName == this.editStrategyData.strategyFirmware) {
            strategyFirmware = item.id;
          }
        });
        let params = {
          id: this.strategyListId,
          strategyName: this.editStrategyData.strategyName,
          description: this.editStrategyData.strategyDesc,
          firmwareId: strategyFirmware,
          firmwareType: strategyType,
          baudrate: this.editStrategyData.strategyBaudrate,
          startTime: this.editStrategyData.strategyTime
            ? this.$filter.formatDate(this.editStrategyData.strategyTime[0])
            : "",
          endTime: this.editStrategyData.strategyTime
            ? this.$filter.formatDate(this.editStrategyData.strategyTime[1])
            : "",
          strategyType: this.editStrategyData.upradeType,
          note: this.editStrategyData.note,
          i18n: this.$lang.currentLang
        };
        this.$request
          .put("/upg/api/auth/web/strategy/update", params)
          .then(res => {
            if (res.code == 0) {
              this.$message.success(this.$t("upgradeManagement.eidt_success"));
              this.queryGetStrategyList();
            } else {
              this.$message.error(res.message);
            }
            this.editdialog = false;
          });
      });
    },
    // 查看策略
    viewStrategy(info) {
      this.strategynewValue = 3;
      this.strategynewListParam = info;
      // this.$router.push({
      //   path: "viewstrategy",
      //   query:{
      //     id:info.id
      //   }
      // });
    },
    // 删除策略
    DeleteStrategy(info){
      this.StrategyID = info.id;
      this.deleteFirmwareVisible = true;
    },
    // 确认删除
    deletetoCL(){
      let param = {
        operate:'delete',
        id:  this.StrategyID
      };
      this.$request
        .get("deviceFirmwareUpgradeStrategy", param)
        .then(res => {
            this.deleteFirmwareVisible = false;
          if (res.err == 0) {
            this.$message.success(this.$t("upgradeManagement.delete_success1"));
            this.queryGetStrategyList()
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
          }
        });
    },
    // 取消策略
    delStrategy(info) {
      this.cenceldialog = true;
      this.strategyListId = info.id;
    },
    // 取消策略提交
    configdelete() {
      this.$request
        .get("deviceFirmwareUpgradeStrategy", { id: this.strategyListId,operate:'cancel'})
        .then(res => {
          if (res.err == 0) {
            this.$message.success(this.$t("upgradeManagement.delete_success"));
            this.queryGetStrategyList();
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
          }
          this.cenceldialog = false;
        });
    },
    // 关于搜索弹窗 =====
    // 关闭搜索框
    closeSearch() {
      this.showSearch = false;
      Object.assign(this.$data.search, this.$options.data.call(this).search);
      this.queryGetStrategyList();
    },
    showSearchBtn() {
      this.showSearch = true;
      this.$nextTick(() => {
        this.$refs.iptFocus.focus();
      });
    },
    showStrategyNewListBox(val) {
      this.strategynewValue = val;
      this.closeSearch();
    },
    addstrategy() {
      this.strategynewValue = 2;
      // this.$router.push({
      //   path: "addstrategy",
      // });
    }
  },
  mounted() {}
};
</script>
  <style lang="less" scoped>
@import url("../../assets/css/mixin.less");

.stategyNew {
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow: auto;
  margin: 20px;
  .selectClearNew {
    width: 150px !important;
  }
  /deep/.el-textarea__inner,
  .el-input__inner {
    background: #2b3842;
    color: #fff;
    border: 1px solid #a3a9b5;
  }
  // 时间"-"号调整
  // /deep/.el-range-separator{
  //   line-height: normal !important;
  //   color: red !important;
  // }
  /deep/.el-form-item__label {
    color: rgba(255, 255, 255, 1);
  }
  /deep/.el-form-item {
    color: rgba(255, 255, 255, 1);
  }

  /deep/.el-input .el-input__inner {
    background-color: #2b3842;
    border: 1px solid #a3a9b5;
  }
  /deep/.el-select {
    width: 100%;
  }
  /deep/.el-radio__input.is-checked + .el-radio__label {
    color: @primaryTextColor !important;
  }
  /deep/.el-radio__input.is-checked .el-radio__inner {
    background: @primaryTextColor !important;
    border-color: #28d4c1 !important;
  }
  /deep/.el-form-item__label {
    color: rgba(255, 255, 255, 1);
  }
  .grid {
    grid-row-gap: 28px;
    padding-bottom: 0px;
  }

  // 统一按钮
  .btn {
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
  }

  .btn-dark {
    background: @primaryTextColor;
    color: rgba(34, 45, 53, 1);
    border: none;
  }

  .btn-light {
    background: transparent;
    color: @primaryTextColor;
    border: 1px solid @primaryTextColor;
  }
  .stategyIntro {
    color: #f3fafe;
    background-color: #222d35;
    padding: 0 20px;
    font-weight: 700;
    margin-bottom: 20px;
    overflow: auto;
    .stategyIntroTitle {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding-top: 10px;
    }
    .strategyIntro {
      display: inline-block;
      background-color: @primaryTextColor;
      width: 13px;
      height: 13px;
      border-radius: 13px;
      margin: 0 15px;
    }
    .stategyStep {
      display: flex;
      justify-content: space-between;
      margin: 10px 0;
      height: 134px;
      padding:0 43px 0 0;
      width: 100%;
      .stategyStepDiv {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        position: relative;
        width:30% ;
        .stategyStepOne {
          z-index: 4;
          padding: 0 5px 0 15px;
          border-radius: 8px 0 0 8px;
          width: 100%;
          background-color: #2b3842;
          p:first-child {
            font-size: 28px;
            padding: 12px 0 5px;
          }
          p:last-child {
            overflow: hidden;
            height: 60px;
            font-size: 12px;
            font-weight: 400;
            padding: 5px 0 5px;
            line-height: 19px;
          }
          p:nth-child(2) {
            height: 19px;
            overflow: hidden;
          }
        }
        .stategyTriangle {
          z-index: 3;
          position: absolute;
          left: calc(100% - 42.5px);
          width: 85px;
          height: 85px;
          transform: rotate(-60deg) skewX(-30deg) scale(1, 0.8);
          border-bottom-right-radius: 10%;
          border-top-right-radius: 10%;
          border-bottom-left-radius: 10%;
          background-color: #2b3842;
        }
      }
    }
  }

  .search {
    margin: 0px;
    // align-self: flex-end;
    align-items: center;
    display: flex;
    justify-content: space-between;
    position: relative;
    /deep/.el-range-editor .el-range-input {
      background-color: #222d35;
      color: #fff;
    }
    /deep/.el-range-separator {
      color: #fff !important;
      line-height: 48px !important;
    }
    /deep/.el-icon-date:before {
      content: "";
      display: inline-block;
      position: absolute;
      top: 12px;
      left: 0px;
      height: 24px;
      width: 24px;
      background: url(../../assets/img/general/Icon_Calendar.png) no-repeat;
      background-size: 100%;
      background-position: center;
    }
    .searchRight {
      display: flex;
      justify-content: flex-end;
      .buttonDeviceJurisdiction {
        padding: 0 17px 0 12px;
        background-color: @primaryTextColor;
        color: #222d35;
        border-radius: 0;
        span {
          padding-left: 5px;
        }
      }
    }
    .search-label {
      display: inline-block;
      color: #ffffff;
      font-weight: bold;
      line-height: 48px;
      font-size: 14px;
      padding-left: 16px;
    }
    /deep/.el-select {
      width: 120px;
      border-right: 1px solid #738089;
    }

    /deep/.el-select:hover {
      background: @primaryColorTransparency30;
    }

    /deep/.el-input {
      width: 100%;
      text-align: center;
    }

    /deep/.el-input__inner {
      background: transparent;
      border: none;
      height: 48px;
      line-height: 48px;
      color: #ffffff;
      padding: 0 16px;
    }

    /deep/.el-input__suffix {
      right: 0px;
    }

    .button {
      height: 48px;
      line-height: 48px;
      padding: 0 25px;
      margin-top: 0px;
      color: @primaryTextColor;
      background: transparent;
      border: none;
    }
    .search-alert {
      position: absolute;
      top: 0;
      left: 0;
      // right: 125px;
      width: 100%;
      height: 48px;
      z-index: 0;
      background: rgb(34, 45, 53);
      display: flex;
      align-items: center;
      justify-content: space-between;

      .searchDiv {
        position: absolute;
        top: 0;
        // left: 0;
        right: 0;
        width: 400px;
        height: 48px;
        z-index: 2;
        background: rgb(34, 45, 53);
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      .searchAll {
        // display: flex;
        // align-items: center;
        // justify-content: flex-end;
        /deep/.el-input__inner {
          width: 220px;
          padding-left: 10px !important;
        }
      }

      .search-device {
        display: inline-block;
        line-height: 48px;
        padding: 0 15px;
        font-size: 14px;
        background: #202d35;
        color: #33ffb6;
        cursor: pointer;

        &:hover {
          background: @primaryColorTransparency30;
          color: rgb(255, 255, 255, 1);
        }
      }

      .search-hide {
        display: inline-block;
        // position: absolute;
        // right: -58px;
        line-height: 48px;
        padding: 0 15px;
        font-size: 14px;
        background: #202d35;
        color: #7b8395;
        border-left: 1px solid #7b8395;
        cursor: pointer;

        &:hover {
          background: @primaryColorTransparency30;
          color: rgb(255, 255, 255, 1);
        }
      }

      /deep/.el-input {
        flex: 1;
      }

      /deep/.el-input .el-input__clear {
        width: 48px;
        color: #7b8395;
      }

      /deep/.el-input .el-input__clear:hover {
        background: @primaryColorTransparency30;
        color: rgb(255, 255, 255, 1);
      }

      /deep/.el-input .el-input__inner,
      /deep/.el-input .el-input__inner:hover {
        height: 48px;
        border-radius: 0px;
        border: none;
        background: #202d35;
        color: #ffffff;
        padding-left: 40px;
      }

      /deep/.el-input__prefix {
        left: 0px;
      }

      /deep/.el-input__icon {
        width: 40px;
      }

      /deep/.el-input__suffix {
        right: 0px;
      }

      /deep/.el-input__suffix:hover {
        background: @primaryColorTransparency30;
        color: rgb(255, 255, 255, 1);
      }

      /deep/.el-icon-circle-close:before {
        content: "X";
      }

      /deep/.el-input:not(:last-child) {
        margin-right: 0px;
      }
    }
    .button-upload {
      display: flex;
      //多语言状态下文字间隔优化
      line-height: 16px;
      justify-content: space-between;
      align-items: center;
      width: 120px;
      height: 48px;
      background: @primaryTextColor;
      color: rgb(34, 45, 53);
      font-size: 14px;
      border-radius: 0px;
      border: none;
      cursor: pointer;
      .ico-download {
        width: 16px;
        height: 16px;
        background: url(../../assets/img/general/Icon_Download.png) no-repeat;
        background-size: 100%;
        background-position: center;
        margin-left: 10px;
      }
    }
  }
  .section {
    flex: 1;
    display: flex;
    border-radius: 0px;
    border: none;
    flex-direction: column;
    background: rgb(34, 45, 53);
    padding: 0px;
    overflow: auto;
    /deep/.el-icon-loading {
      font-size: 28px;
    }
    .tableloding {
      // 加载数据时遮罩
      /deep/.el-loading-mask {
        background-color: rgb(34, 45, 53, 0.5);
      }

      /deep/.el-loading-spinner i {
        color: @primaryTextColor;
      }
    }
    .tablemain {
      border: none;
      background-color: rgb(34, 45, 53);
      .operation i {
        color: @primaryTextColor;
      }
      .operation1 i {
        color: @primaryColorTransparency30;
      }

      /deep/.el-table--border::after,
      /deep/.el-table--group::after {
        width: 0px;
      }

      /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner {
        width: 16px;
        height: 16px;
        background: transparent;
        border: 1px solid rgb(180, 184, 193);
        border-radius: 0px;
      }

      /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner::after {
        top: 2px;
        left: 5px;
      }

      /deep/.el-table__header th {
        height: 48px;
      }

      /deep/.el-table__header th.is-leaf {
        border-color: rgba(198, 209, 221, 0.5);
        border-bottom: none;
      }

      /deep/.el-table__header th > .cell {
        font-weight: normal;
        font-size: 12px;
      }

      /deep/.el-table__body tr,
      /deep/.el-table__body td {
        background-color: rgb(34, 45, 53);
        color: #ffffff;
        border-color: rgba(198, 209, 221, 0.5);
      }

      /deep/.el-table__body td.el-table-column--selection {
        background-color: rgb(65, 80, 90);
        color: #ffffff;
      }

      /deep/.el-table__body .cell.el-tooltip {
        font-size: 14px;
      }

      /deep/.el-table__fixed-right::before,
      /deep/.el-table__fixed::before {
        display: none;
      }

      ::-webkit-scrollbar {
        width: 6px;
        height: 6px;
        background-color: #222d35;
      }

      // 关于头部右侧空白
      /deep/.el-table__fixed-right-patch {
        background-color: rgb(65, 80, 90);
        border-bottom: none;
      }

      /deep/th.gutter {
        background-color: rgb(65, 80, 90);
      }
    }
    .tablebottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-top: 1px solid rgba(198, 209, 221, 0.5);

      // 分页
      .pagination {
        line-height: 48px;
        height: 48px;
        padding: 0;
        margin: 0;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-right: 16px;

        /deep/.el-pager li {
          vertical-align: middle;
        }

        /deep/.el-select .el-input {
          width: 90px;
          margin: 0px;
        }

        /deep/.el-input .el-input__inner {
          background-color: #202d35;
          color: #ffffff;
        }

        /deep/.el-input__suffix {
          right: 10px;
        }

        /deep/.el-pagination__sizes {
          margin: 0px;
          height: 48px;
          line-height: 48px;
        }

        /deep/.el-pagination__total {
          color: #fff;
          padding-left: 15px;
          border-left: 1px solid #7b8395;
          height: 48px;
          line-height: 48px;
        }

        /deep/.el-pager li:not(.disabled).active {
          // background: #15C491;
          // color: #ffffff;
          background-color: #2b3842;
          color: #15c491;
        }

        // li:not(.disabled):not(.active):hover
        /deep/.el-pager li:not(.disabled):hover {
          background-color: @primaryColorTransparency30;
          color: rgba(255, 255, 255, 1);
        }

        /deep/.el-pager li {
          background-color: #2b3842;
          color: #7b8395;
        }

        // 页条数下拉
        /deep/.el-select .el-input .el-input__inner {
          border: none;
          height: 48px;
          line-height: 48px;
          border-radius: 0px;
        }

        /deep/.el-select .el-input .el-input__inner:hover {
          background: @primaryColorTransparency30;
        }

        // 跳页
        /deep/.el-pagination__jump {
          color: #ffffff;
        }

        /deep/.el-pagination__editor {
          padding: 0px 6px;
        }

        /deep/.el-pagination__editor.el-input .el-input__inner {
          border: 1px solid #7b8395;
        }
      }

      // 分页前后按钮
      /deep/.el-pagination.is-background .btn-next,
      /deep/.el-pagination.is-background .btn-prev {
        background-color: #2b3842;
        color: #7b8395;
      }

      /deep/.el-pagination.is-background .btn-next:hover,
      /deep/.el-pagination.is-background .btn-prev:hover {
        background-color: @primaryColorTransparency30;
        color: rgba(255, 255, 255, 1);
      }

      /deep/.el-pagination.is-background button[disabled],
      /deep/.el-pagination.is-background button[disabled]:hover {
        background-color: #2b3842;
        color: #7b8395;
      }
    }
  }
}
</style>
  <style lang="less">
.select-date1.el-picker-panel {
  background-color: #222d35;
  border: none;
  padding-top: 10px;
  .el-picker-panel__body-wrapper {
    .el-picker-panel__body {
      border: #222d35;
    }
    .el-picker-panel__sidebar {
      width: 100%;
      position: relative;
      padding: 0px;
      background: transparent;
      color: #ffffff;
      border: none;
      .el-picker-panel__shortcut,
      .el-picker-panel__shortcut:hover {
        // margin-top: 0px;
        padding-left: 0px;
        padding-bottom: 20px;
        color: rgba(48, 208, 150, 1);
        text-align: center;
      }
    }
  }
  .el-date-range-picker__header {
    color: #fff;
  }
  .el-date-table td.end-date span,
  .el-date-table td.start-date span {
    background-color: rgba(48, 208, 150, 0.8);
    border: rgba(48, 208, 150);
  }
  .in-range {
    background-color: #222d35;
  }
  .el-picker-panel__shortcut:hover {
    padding-left: 0px;
    padding-bottom: 20px;
    color: rgba(48, 208, 150, 1);
    text-align: center;
  }
  .el-date-table td.today span {
    color: rgba(48, 208, 150, 1);
    font-weight: 700;
  }
  .el-date-table td.start-date span {
    color: #fff;
    font-weight: 700;
  }
  .el-date-table td.end-date span {
    color: #fff;
    font-weight: 700;
  }
  .el-date-table td.in-range div {
    background-color: rgba(48, 208, 150, 0.7);
  }
  .el-picker-panel__icon-btn {
    color: rgba(48, 208, 150);
    font-size: 14px;
    font-weight: bold;
  }
  .el-date-table td.in-range {
    background-color: #222d35;
  }
  .el-date-table td:hover {
    color: rgba(48, 208, 150);
  }
  .el-date-table td.next-month,
  .el-date-table td.prev-month {
    color: #606266;
  }
  .el-date-table td {
    color: #fff;
  }
}
.el-date-table td.disabled div {
  background-color: #222d35 !important;
  color: #606266 !important;
}

.edit_data {
  .select-date1.el-picker-panel {
    background-color: #222d35;
    border: none;
    padding-top: 10px;
    .el-picker-panel__body-wrapper {
      .el-picker-panel__body {
        border: #222d35;
      }
      .el-picker-panel__sidebar {
        width: 100%;
        position: relative;
        padding: 0px;
        background: transparent;
        color: #ffffff;
        border: none;
        .el-picker-panel__shortcut,
        .el-picker-panel__shortcut:hover {
          // margin-top: 0px;
          padding-left: 0px;
          padding-bottom: 20px;
          color: rgba(48, 208, 150, 1);
          text-align: center;
        }
      }
    }
    .el-date-range-picker__header {
      color: #fff;
    }
    .el-date-table td.end-date span,
    .el-date-table td.start-date span {
      background-color: rgba(48, 208, 150, 0.8);
      border: rgba(48, 208, 150);
    }
    .in-range {
      background-color: #222d35;
    }
    .el-picker-panel__shortcut:hover {
      padding-left: 0px;
      padding-bottom: 20px;
      color: rgba(48, 208, 150, 1);
      text-align: center;
    }
    .el-date-table td.today span {
      color: rgba(48, 208, 150, 1);
      font-weight: 700;
    }
    .el-date-table td.in-range div {
      background-color: rgba(48, 208, 150, 0.7);
    }
    .el-picker-panel__icon-btn {
      color: rgba(48, 208, 150);
      font-size: 14px;
      font-weight: bold;
    }
    .el-date-table td.in-range {
      background-color: #222d35;
    }
    .el-date-table td:hover {
      color: rgba(48, 208, 150);
    }
    .el-date-table td.next-month,
    .el-date-table td.prev-month {
      color: #606266;
    }
    .el-date-table td {
      color: #fff;
    }
  }
  .el-date-table td.disabled div {
    background-color: #2b3842 !important;
    color: #606266 !important;
  }
  .el-range-editor .el-range-input {
    background-color: #2b3842;
    color: #fff;
  }
  .el-range-separator {
    color: #fff !important;
    line-height: 32px !important;
  }
  .el-icon-date:before {
    content: "";
    display: inline-block;
    position: absolute;
    top: 8px;
    left: 10px;
    height: 24px;
    width: 24px;
    background: url(../../assets/img/general/Icon_Calendar.png) no-repeat;
    background-size: 100%;
    background-position: center;
  }
}
</style>